import { Divider } from "@mui/material";
import { useEffect, useState } from "react";
import { Subtitulo } from "../..";
import parseHtml from "html-react-parser";
import CardCustom from "../../Card";

const OperacaoBancarioRecebimento = ({ dadosBancarios, isTodosDetalhes }) => {
  const [dadosBancariosDescricao, setdadosBancario] = useState([]);

  useEffect(() => {
    if (dadosBancarios?.dadosBancarios)
      setdadosBancario(dadosBancarios?.dadosBancarios.split("|"));
  }, [dadosBancarios]);

  return (
    <>
      <CardCustom>
        <Subtitulo sx={{ color: "#000", fontWeight: "BOLD" }}>
          💵 Segue os dados de onde deseja receber o seu dinheiro
        </Subtitulo>
        <hr />
        {!!dadosBancariosDescricao.length ? (
          <>
            {dadosBancariosDescricao.map((d, index) => (
              <Subtitulo
                key={index}
                sx={{ fontWeight: "bold", mb: 1, color: "#000" }}
              >
                {d.replace(":", ": ")}
              </Subtitulo>
            ))}

            {dadosBancarios && dadosBancarios.chavePIX !== "" && (
              <Subtitulo sx={{ fontWeight: "bold", mb: 1, color: "#000" }}>
                Chave PIX: {dadosBancarios.chavePIX}
              </Subtitulo>
            )}
          </>
        ) : (
          <>
            <Subtitulo style={{ color: "#fff !important" }}>
              Nenhum dado bancário encontrado
            </Subtitulo>
          </>
        )}
      </CardCustom>
    </>
  );
};

export default OperacaoBancarioRecebimento;
